import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import {
	Observable,
	throwError,
} from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class Interceptor implements HttpInterceptor {
	private readonly excludedRoutes = ['/ExecutiveDashboard', '/Dashboard'];

	constructor(private readonly router: Router) {

	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			catchError((err) => {
				return this.managementError(err);
			}
			));
	}

	private isExcluded(): boolean {
  const currentUrl = this.router.url.split('?')[0].split('#')[0];
  return this.excludedRoutes.some((route) =>
    currentUrl.toLowerCase().startsWith(route.toLowerCase())
  );
}

	managementError(err: HttpErrorResponse) {
		if (this.isExcluded() || err.url?.includes('Search/Global')) {
			return throwError(() => err);
        }
			  
		if (err.status === 404) {
			this.router.navigate(['error/404'], { skipLocationChange: true });
			return throwError(() => err);
		}

		if (err.status === 500) {
			this.router.navigate(['error/500'], { skipLocationChange: true });
			return throwError(() => err);
		}

		if (err.status === 403) {
			this.router.navigate(['error/403'], { skipLocationChange: true });
			return throwError(() => err);
		}

		if (err.status === 0) {
			if (err.error && typeof err.error === 'object') {
				err.error.Message = err.message;
			}
		}

		return throwError(() => err);

	}

}
